import axios from 'axios';
// eslint-disable-next-line
import { AXIOS_DEFAULT_CONFIG, URl_DEFAULT_CONFIG } from '@/config'; // 拿到axios配置
import {
  request,
  requestErr,
  response,
  responseErr,
} from '@/config/interceptors/axios'; // 拿到axios 拦截器配置

const { CancelToken } = axios; // 取消请求的对象

const sourceToken = CancelToken.source(); // 拿到取消请求令牌对象

AXIOS_DEFAULT_CONFIG.cancelToken = sourceToken.token; // 每次请求的取消token都设置为同一个，方便统一取消

const axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG); // 用配置文件创建axios实例

axiosInstance.interceptors.request.use(request, requestErr); // 设置请求拦截器

axiosInstance.interceptors.response.use(response, responseErr); // 设置响应拦截器

// 遍历检查URl_DEFAULT_CONFIG，设置对应默认url
URl_DEFAULT_CONFIG.forEach((key, value) => {
  // 如果key为数组
  if (Array.isArray(key) && key.filter(val => document.location.host.indexOf(val)).length > 0) {
    axiosInstance.defaults.baseURL = value; // 设置对应的默认url
  }
  if (document.location.host.indexOf(key) !== -1) {
    axiosInstance.defaults.baseURL = value; // 设置对应的默认url
  }
});

export {
  axiosInstance,
  sourceToken,
};
